import { CurrentUser } from 'js/core_post_webpack/models/user';

declare global {
  interface Window {
    // This gets set in _dependencies.html.erb,
    // simple.html.erb for the LOSWP, or, for pages under a layout that renders
    // neither, the page template itself (premium_upgrade/default_react.html.slim).
    // It is undefined on logged-out pages.
    $current_user?: string | CurrentUser;
  }
}

export const currentUser: CurrentUser | null = (() => {
  // SSR: During server-side rendering in Node.js, window is undefined
  // Return null to ensure server-rendered HTML doesn't depend on client-only data
  if (typeof window === 'undefined') return null;

  // In the browser, retrieve the current user from the global variable
  // set by Rails in the page template
  const jsonOrUser = window.$current_user;
  if (jsonOrUser == null) return null;
  if (typeof jsonOrUser === 'string') {
    const user: CurrentUser = JSON.parse(jsonOrUser);
    return user;
  } else {
    return jsonOrUser;
  }
})();

export const current = currentUser;
